module.exports = __webpack_public_path__ + "img/DSC_1107.6805a176.jpg";